import { KYC_STATUS } from "src/scenes/NewVerification/consts/kyc";

export const RECEIVING_METHOD = {
  BANK_TRANSFER: 1,
  DEPOSIT: 2
};

// List of KYC status that's allowed to use most of AP features
// Based on this document: https://docs.google.com/spreadsheets/d/1PwAyKEOkxYBYgp3iyK0hGFQROd-arS2L97uhEiXQVTw/edit#gid=1301171441
export const ALLOWED_KYC_STATUS_AP_FEATURES = [
  KYC_STATUS.APPROVED,
  KYC_STATUS.NEGOTIATE,
  KYC_STATUS.REQUESTED,
  KYC_STATUS.REJECTED,
  KYC_STATUS.DONE
];
